import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-buy-sell-approval-summary',
  templateUrl: './buy-sell-approval-summary.component.html',
  styleUrls: ['./buy-sell-approval-summary.component.scss']
})
export class BuySellApprovalSummaryComponent implements OnInit {
  @Input() buySellPlanEmployee: any;
  @Input() selectedType: string;
  @Input() compensation: any;

  constructor() { }

  ngOnInit(): void {
  }

  getStatusChipClass(): string {
    const statusId = this.buySellPlanEmployee?.status?.id;
    const classMap = {
      'DENIED': 'red-chip',
      'APPROVED': 'green-chip',
      'COMPLETE': 'green-chip',
      'PENDING': 'orange-chip',
      'PENDING_APPROVAL': 'blue-chip',
      'AVAILABLE': 'blue-chip'
    };
    return classMap[statusId] || '';
  }

}
